import * as React from "react";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {RootState} from "../../../store/reducer/root/RootState";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import DictionarySortableItemsList from "../common/DictionarySortableItemsList";
import {createCategory, updateCategoriesSortOrder, updateCategory} from "../../../store/action/category/category";

interface ReduxProps {
	/**
	 * All categories.
	 */
	categories: DictionaryItem[];
}

interface DispatchProps {
	/**
	 * Sort order update action.
	 * @param {DictionaryItem[]} categories
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateSortOrder: (categories: DictionaryItem[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Create category.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createCategory: (category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Update category.
	 * @param {string} cId
	 * @param {DictionaryItem} category
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateCategory: (cId: string, category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = ReduxProps & DispatchProps;

/**
 * Categories config view.
 */
class CategoriesConfigView extends React.Component<Props, {}> {
	render() {
		return (
			<DictionarySortableItemsList title={"Category"}
										 items={this.props.categories}
										 updateItem={this.props.updateCategory}
										 createItem={this.props.createCategory}
										 updateSortOrder={this.props.updateSortOrder}/>
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		categories: [].concat(state.category.categories.getOrElse([]))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateSortOrder: (categories: DictionaryItem[], onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateCategoriesSortOrder(categories, onSuccess, onFailure)),
		createCategory: (category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createCategory(category, onSuccess, onFailure)),
		updateCategory: (cId: string, category: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateCategory(cId, category, onSuccess, onFailure))
	}
}

export default connect<ReduxProps, DispatchProps, null>(mapStateToProps, mapDispatchToProps)(CategoriesConfigView)